import axios from "axios";

const ClassNote = {
  namespaced: true,
  actions: {
    CreateClassNote({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .post(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/CreateClassNote`,
            payload,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    UpdateClassNote({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .post(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/UpdateClassNote`,
            payload,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GetClassNotes({ rootState }, { SchoolSubjectId }) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .get(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/PortalGetClassNotes?SchoolSubjectId=${SchoolSubjectId}`,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GetClassNoteById({ rootState }, ClassNoteId) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .get(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/PortalGetByIdClassNote?ClassNoteId=${ClassNoteId}`,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    CreateClassNoteLesson({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .post(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/CreateClassNoteLesson`,
            payload,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    UpdateClassNoteLesson({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .post(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/UpdateClassNoteLesson`,
            payload,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GetClassNoteLessons({ rootState }, { ClassNoteId }) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .get(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/PortalGetClassNoteLessons?ClassNoteId=${ClassNoteId}`,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GetClassNoteLessonById({ rootState }, ClassNoteLessonId) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .get(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/PortalGetByIdClassNoteLesson?ClassNoteLessonId=${ClassNoteLessonId}`,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    CreateClassNoteLessonQuestion({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .post(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/CreateClassNoteLessonQuestion`,
            payload,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    UpdateClassNoteLessonQuestion({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .post(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/UpdateClassNoteLessonQuestion`,
            payload,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GetClassNoteLessonQuestions({ rootState }, { ClassNoteLessonId }) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .get(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/PortalGetClassNoteLessonQuestion?ClassNoteLessonId=${ClassNoteLessonId}`,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GetClassNoteLessonQuestionById({ rootState }, ClassNoteLessonQuestionId) {
      return new Promise((resolve, reject) => {
        const headers = {
          Authorization: `bearer ${rootState.auth.token}`,
        };
        axios
          .get(
            `${process.env.VUE_APP_ENV_API_URL}ClassNote/PortalGetByIdClassNoteLessonQuestion?ClassNoteLessonQuestionId=${ClassNoteLessonQuestionId}`,
            { headers }
          )
          .then((resp) => resp.data)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default ClassNote;
